import messages from "messages";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
// components
import ContactSelector from "components/contact-selector/ContactSelector";
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
// hooks
import useToggleModal from "hooks/useToggleModal";
// styles
import styles from "./styles.module.scss";

type Props = {
  onApply: (arg: PatientChartContact) => void;
};

/**
 * renders a button to control show/hide of the contact selector
 */
const AddExistingContact = ({ onApply }: Props) => {
  const { open, close, show } = useToggleModal(false);

  const handleApply = useCallback<typeof onApply>(
    (arg) => {
      onApply(arg);
      close();
    },
    [onApply, close],
  );

  return (
    <>
      <Button
        variant={"link"}
        onClick={open}
        className={styles["add-existing-contact"]}
      >
        <OutlinePlus16 className={"mr-2"} />
        {messages.addExistingClientOrContact}
      </Button>
      <ContactSelector show={show} onHide={close} onApply={handleApply} />
    </>
  );
};

export default AddExistingContact;
